var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2dedd",
    d: "M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32 14.327 0 32 0s32 14.327 32 32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.916 9.5c6-3 13.42-.7 17 5.5 1.732 3 .902 7 .5 8.5-.404 1.508-1.877 6.942-2 8.5l-.004.043c-.353 4.468-.566 7.178-2.996 10.957-4.23 6.58-8.46 10.95-10.613 19.34-7.938-2.667-14.484-8.36-18.269-15.71 1.1-3.675 1.492-6.402 1.882-9.13.536-3.753.601-5.976 2-9.5 1.162-2.926 2.324-4.335 4-7 2.973-4.727 3.505-9.002 8.5-11.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.213 25.845c-.286 1.067-1.167 1.758-1.967 1.543-.8-.214-1.217-1.253-.931-2.32s1.166-1.758 1.966-1.544c.8.215 1.218 1.254.932 2.32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7686",
    d: "M24.428 24.31c2 1 3.317.543 4.39 1.592 1.073 1.05-.033 4.998-.033 8.129 0 4 1.131 5.58.131 6.08-1.588.794-2.708.774-3.967 1.495-1.198.687-1.484 1.153-2.533 1.894-1.128.796-2.761.855-4.454.382-1.369-.382-2.518-.987-3.453-2.382-.91-1.358-.425-1.69-1.37-4.032-.731-1.814-1.941-2.085-1.941-3.468 0-1 2.912-2.858 4.587-6.075 2.355-4.523 3.295-5.562 4.642-5.562 1.295 0 2.084.988 4.001 1.947"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.916 19.412c-.286 1.067-1.166 1.758-1.966 1.543-.8-.214-1.217-1.253-.931-2.32.285-1.067 1.166-1.758 1.966-1.543.8.214 1.217 1.253.931 2.32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e66a79",
    d: "M25.744 33.596a.5.5 0 1 1 1 0v2a.5.5 0 1 1-1 0zM16.73 30.258a.5.5 0 1 1 .812.583l-1.167 1.624a.5.5 0 1 1-.812-.583z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e6e3b4727d230d4410f831280cc57bd0.svg";
export { ForwardRef as ReactComponent };